import { render, staticRenderFns } from "./ExamDetails.vue?vue&type=template&id=6a0bb6da&scoped=true"
import script from "./ExamDetails.vue?vue&type=script&lang=js"
export * from "./ExamDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0bb6da",
  null
  
)

export default component.exports